<!-- Email Basket -->
<!-- <div class="email-bucket" *ngIf="leads.length > 0"> -->
<div class="email-bucket">
	<div class="notialert" [ngClass]="{'alertNotishow': showalertNoti}">
	 <p>ID Copied</p>
	</div>
	<div class="email-header" (click)="toggleEmailBucket()">
    <!-- Email Basket <span>({{ properties.length }} Properties)</span> -->
		<!-- <i class="fa fa-bell" aria-hidden="true"></i>  -->
		Alerts
		<div class="email-window-icon">
			<a class="" [ngClass]="{'hide': hideEmailBucket}" href="javascript:;"><i class="fa fa-window-maximize" aria-hidden="true"></i></a>
			<a href="javascript:;" [ngClass]="{'hide': !hideEmailBucket}"><i class="fa fa-window-minimize" aria-hidden="true"></i></a>
		</div>
	</div>

	<div class="basket-content" [ngClass]="{'hide': !hideEmailBucket}">
		<!-- <div class="email-body modal-body" *ngFor="let lead of leads; let indx = index"> -->
		<div class="email-body modal-body">
			<ul class="headTab d-flex align-items-center">
		    <h1 class="page-name" [ngClass]="{'active': alertType == 'lead'}"   (click)="selectAlertType('lead')">Leads</h1>
		    <h1 class="page-name" [ngClass]="{'active': alertType == 'unpaid'}" (click)="selectAlertType('unpaid')">Unpaid Orders</h1>
		  </ul>

			<!-- Loader -->
			<div class="faSpinner" *ngIf="loadingAlerts">
				<i class="fa fa-spinner fa-spin"></i>
			</div>

			<ng-select
					[items]="allLeadAlertsBuffer"
					[virtualScroll]="true"
					[loading]="loading"
					dropdownPosition="auto"
					[clearable]="false"
					[searchable]="false"
					#bathSelecthome
					Name="lead_id"
					(scroll)="onScroll($event)"
					(scrollToEnd)="onScrollToEnd()"
					[isOpen]="true"
					*ngIf="!loadingAlerts"
					(selected)="selected($event)"
					>
					<ng-template ng-option-tmp let-item="item" let-index="index">
						<!-- <div class="email-content-box" (click)="goToMissedAlert(item.id)"> -->
						<div class="email-content-box">
							<div class="p-0">

								<p class="alert_heading" *ngIf="item.alertStatus == 'Upcoming Alert'; else missedAlert">
									<svg width="28" height="16" viewBox="0 0 28 16" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M21.0792 0.0180956L8.2424 3.62054C7.12799 3.93448 5.97522 4.09301 4.81755 4.09223H3.62041C2.67381 4.05387 1.75264 4.4046 1.06953 5.06262C0.386044 5.72064 0 6.6296 0 7.57959C0 8.52958 0.386054 9.43859 1.06953 10.097C1.75263 10.755 2.67388 11.1053 3.62041 11.0674H4.81795H4.81756C5.2403 11.0693 5.66265 11.0936 6.08225 11.1406V12.4312C6.08381 13.346 6.44683 14.2228 7.09203 14.8699C7.73723 15.5169 8.61164 15.881 9.52389 15.8822H10.3073C11.1044 15.8771 11.875 15.5941 12.4873 15.0825C13.0998 14.5708 13.5159 13.8619 13.665 13.0763L21.0574 15.147C21.1074 15.1552 21.1581 15.1552 21.2085 15.147C21.3314 15.1486 21.4513 15.109 21.5496 15.035C21.6886 14.9278 21.7694 14.7618 21.7678 14.5861V0.556672C21.7694 0.380914 21.6886 0.214936 21.5496 0.107681C21.4142 0.00864595 21.2417 -0.024235 21.0797 0.0180405L21.0792 0.0180956ZM3.61971 9.94509C2.97408 9.9768 2.34402 9.74154 1.87606 9.29451C1.40809 8.84747 1.14299 8.22777 1.14299 7.57962C1.14299 6.93178 1.40803 6.31176 1.87606 5.86512C2.34408 5.4181 2.97407 5.18283 3.61971 5.21454H4.81725C5.24272 5.21454 5.66234 5.21454 6.08194 5.14721V10.0125C5.66232 9.97336 5.2427 9.94518 4.81725 9.94518L3.61971 9.94509ZM10.3348 14.7657H9.55138C8.92955 14.7731 8.33075 14.53 7.88887 14.0916C7.44738 13.6528 7.19952 13.0546 7.20108 12.4311V11.3089C7.5481 11.3762 7.89511 11.4549 8.24174 11.55L12.5952 12.7733H12.5956C12.516 13.3256 12.2412 13.831 11.8208 14.197C11.4008 14.5626 10.8633 14.7646 10.3067 14.7657L10.3348 14.7657ZM20.6984 13.8622L8.53309 10.4559C8.09082 10.3326 7.63764 10.2426 7.18995 10.1584V5.00109C7.63768 4.91693 8.09086 4.82729 8.53309 4.70359L20.6594 1.29725L20.6984 13.8622Z" fill="black"/>
									<path d="M26.4422 7.01611H24.3605C24.0514 7.01611 23.8008 7.26703 23.8008 7.57706C23.8008 7.88709 24.0514 8.13839 24.3605 8.13839H26.4422C26.7514 8.13839 27.0016 7.88709 27.0016 7.57706C27.0016 7.26703 26.7514 7.01611 26.4422 7.01611Z" fill="black"/>
									<path d="M24.3605 4.63052C24.4589 4.62934 24.5557 4.60233 24.6404 4.55184L26.4422 3.50825C26.5773 3.43701 26.6776 3.31409 26.7201 3.16731C26.7627 3.02012 26.7435 2.86237 26.667 2.73006C26.5909 2.59775 26.4641 2.50224 26.3157 2.46584C26.1678 2.42943 26.0112 2.45527 25.8824 2.53708L24.0806 3.58067V3.58106C23.8589 3.7071 23.75 3.96742 23.816 4.21442C23.8816 4.46102 24.1056 4.63209 24.3605 4.63052L24.3605 4.63052Z" fill="black"/>
									<path d="M26.4414 11.6518L24.6396 10.6082C24.3737 10.4684 24.0455 10.564 23.8956 10.8243C23.7453 11.085 23.8269 11.4177 24.0798 11.579L25.8816 12.6225C26.1459 12.7815 26.489 12.6961 26.6483 12.4319C26.7267 12.3016 26.749 12.145 26.7099 11.9978C26.6709 11.8506 26.5737 11.7258 26.4414 11.6518H26.4414Z" fill="black"/>
									</svg>
									 Upcoming Alert
								 </p>
								 <ng-template #missedAlert>
									 <p class="alert_heading">
										  <svg width="27" height="18" viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M13 17C17.416 17 21 13.4161 21 9C21 4.58392 17.4161 1 13 1C8.58392 1 5 4.58392 5 9C5 13.4161 8.58392 17 13 17ZM13 1.64C17.0533 1.64 20.36 4.9467 20.36 9C20.36 13.0533 17.0533 16.36 13 16.36C8.9467 16.36 5.64 13.0533 5.64 9C5.64 4.9467 8.9467 1.64 13 1.64Z" fill="black" stroke="black" stroke-width="0.5"/>
											<path d="M12.8942 10.1734C13.0648 10.1734 13.2141 10.024 13.2141 9.8535L13.2142 5.80016C13.2142 5.62948 13.0648 5.48022 12.8943 5.48022C12.7235 5.48022 12.5742 5.62948 12.5742 5.80016V9.8535C12.5742 10.0242 12.7235 10.1736 12.8942 10.1736V10.1734Z" fill="black" stroke="black" stroke-width="0.5"/>
											<path d="M12.8942 12.7333C13.0648 12.7333 13.2141 12.5839 13.2141 12.4133V11.7733C13.2141 11.6026 13.0647 11.4534 12.8942 11.4534C12.7235 11.4532 12.5742 11.6026 12.5742 11.7733V12.4133C12.5742 12.5839 12.7235 12.7333 12.8942 12.7333Z" fill="black" stroke="black" stroke-width="0.5"/>
											</svg>
											Missed Alert
										</p>
								 </ng-template>

								<ul class="notification_items">
									<li>
										<span *ngIf="alertType == 'lead'; else orderIdtemp">
											ID: <a href="javascript:;" title="Copy to Clipboard" (click)="copytext(siteAbbr[item.site_link] + '-' + item.id)">{{ siteAbbr[item.site_link] + '-' + item.id }}</a>
										</span>

										<ng-template #orderIdtemp>
											ID: <a href="javascript:;" title="Copy to Clipboard" (click)="copytext(item.order_id)">{{ item.order_id }}</a>
										</ng-template>
									</li>

									<li>
										<span>
											<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M12.3594 1.09375H11.7031V0H10.6094V1.09375H3.39062V0H2.29688V1.09375H1.64062C0.735984 1.09375 0 1.82973 0 2.73438V12.3594C0 13.264 0.735984 14 1.64062 14H12.3594C13.264 14 14 13.264 14 12.3594V2.73438C14 1.82973 13.264 1.09375 12.3594 1.09375ZM12.9062 12.3594C12.9062 12.6609 12.6609 12.9062 12.3594 12.9062H1.64062C1.33908 12.9062 1.09375 12.6609 1.09375 12.3594V5.14062H12.9062V12.3594ZM12.9062 4.04688H1.09375V2.73438C1.09375 2.43283 1.33908 2.1875 1.64062 2.1875H2.29688V3.28125H3.39062V2.1875H10.6094V3.28125H11.7031V2.1875H12.3594C12.6609 2.1875 12.9062 2.43283 12.9062 2.73438V4.04688Z" fill="black"/>
												<path d="M3.17188 6.28906H2.07812V7.38281H3.17188V6.28906Z" fill="black"/>
												<path d="M5.35938 6.28906H4.26562V7.38281H5.35938V6.28906Z" fill="black"/>
												<path d="M7.54688 6.28906H6.45312V7.38281H7.54688V6.28906Z" fill="black"/>
												<path d="M9.73438 6.28906H8.64062V7.38281H9.73438V6.28906Z" fill="black"/>
												<path d="M11.9219 6.28906H10.8281V7.38281H11.9219V6.28906Z" fill="black"/>
												<path d="M3.17188 8.47656H2.07812V9.57031H3.17188V8.47656Z" fill="black"/>
												<path d="M5.35938 8.47656H4.26562V9.57031H5.35938V8.47656Z" fill="black"/>
												<path d="M7.54688 8.47656H6.45312V9.57031H7.54688V8.47656Z" fill="black"/>
												<path d="M9.73438 8.47656H8.64062V9.57031H9.73438V8.47656Z" fill="black"/>
												<path d="M3.17188 10.6641H2.07812V11.7578H3.17188V10.6641Z" fill="black"/>
												<path d="M5.35938 10.6641H4.26562V11.7578H5.35938V10.6641Z" fill="black"/>
												<path d="M7.54688 10.6641H6.45312V11.7578H7.54688V10.6641Z" fill="black"/>
												<path d="M9.73438 10.6641H8.64062V11.7578H9.73438V10.6641Z" fill="black"/>
												<path d="M11.9219 8.47656H10.8281V9.57031H11.9219V8.47656Z" fill="black"/>
											</svg>

										{{ item.missedTime | customDatePipe: 'shortMonth' }} at {{ item.missedTime | customDatePipe: 'onlyTime' }}
										</span>
									</li>
									<!-- <li><span>{{ item.item_assigned_agent_name }}</span></li> -->
									<!-- <li><span>Status: {{ item.status }}</span></li> -->

									<li style="text-align: center" title="Assign to Me">
										<a href="javascript:;" *ngIf="!item.loading" (click)="openAssignToMe_Sales_Modal(index)">
											<svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M19.1488 2.87993C16.9664 0.703647 13.8688 -0.384493 10.912 0.123306C10.8416 0.123306 10.8416 0.123306 10.7712 0.195848C10.2784 0.123306 9.7856 0.050763 9.2928 0.050763C6.688 0.050763 4.224 1.06636 2.3936 2.95247C2.112 3.24264 2.112 3.6779 2.3936 3.96807C2.6752 4.25824 3.0976 4.25824 3.3792 3.96807C4.928 2.29959 6.9696 1.42907 9.2224 1.42907C11.4752 1.42907 13.5168 2.29959 14.9952 3.89553C18.2336 7.23249 18.2336 12.6732 14.9952 16.0102C13.4464 17.6786 11.4048 18.5491 9.152 18.5491C6.9696 18.5491 4.8576 17.6061 3.3088 16.0102C3.0272 15.72 2.6048 15.72 2.3232 16.0102C2.0416 16.3003 2.0416 16.7356 2.3232 17.0257C4.1536 18.9119 6.6176 19.9275 9.2224 19.9275C9.7152 19.9275 10.208 19.8549 10.6304 19.8549C10.6304 19.8549 10.6304 19.8549 10.7008 19.8549C11.1936 19.9275 11.7568 20 12.2496 20C14.8544 20 17.3184 18.9119 19.1488 17.0257C22.9504 13.1084 22.9504 6.79723 19.1488 2.87993ZM18.1632 16.0827C17.3184 16.9532 16.3328 17.6061 15.2768 18.0413C15.6288 17.7512 15.9104 17.5335 16.192 17.1708C18.0224 15.2122 19.008 12.7457 19.008 10.0617C19.008 7.37757 18.0928 4.83858 16.192 2.95247C15.84 2.58976 15.488 2.29959 15.0656 2.00942C16.192 2.44467 17.3184 3.09756 18.1632 3.96807C21.4016 7.30503 21.4016 12.7457 18.1632 16.0827Z" fill="#F07527"/>
											<path d="M3.3088 9.9891C3.3088 9.55384 3.0272 9.26367 2.6048 9.26367H0.704C0.2816 9.26367 0 9.55384 0 9.9891C0 10.4244 0.2816 10.7145 0.704 10.7145H2.6048C2.9568 10.7145 3.3088 10.4244 3.3088 9.9891Z" fill="#F07527"/>
											<path d="M4.50555 9.98913C4.50555 10.4244 4.78715 10.7146 5.20955 10.7146H10.8416L7.67355 13.979C7.39195 14.2691 7.39195 14.7044 7.67355 14.9946C7.81435 15.1397 7.95515 15.2122 8.16635 15.2122C8.30715 15.2122 8.51835 15.1397 8.65915 14.9946L13.024 10.4969C13.3056 10.2068 13.3056 9.7715 13.024 9.48133L8.65915 4.98368C8.37755 4.69351 7.95515 4.69351 7.67355 4.98368C7.39195 5.27385 7.39195 5.70911 7.67355 5.99928L10.8416 9.2637H5.20955C4.78715 9.2637 4.50555 9.55387 4.50555 9.98913Z" fill="#F07527"/>
											</svg>
										</a>

										<!-- Loader for action -->
										<i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="item.loading"></i>
									</li>

									<li>
										<ng-container *ngIf="item.alertStatus == 'Upcoming Alert';else missedAlertTime">
											<span class="textOrange">
											<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M7 14C3.14008 14 0 10.86 0 7C0 3.14005 3.14005 0 7 0C10.86 0 14 3.14005 14 7C14 10.86 10.86 14 7 14ZM7 0.736682C3.54632 0.736682 0.736682 3.54632 0.736682 7C0.736682 10.4537 3.54632 13.2633 7 13.2633C10.4537 13.2633 13.2633 10.4537 13.2633 7C13.2633 3.54632 10.4537 0.736682 7 0.736682Z" fill="#FF8831"/>
											<path d="M9.70723 10.0762C9.61288 10.0762 9.51854 10.0402 9.4467 9.96833L6.73875 7.26039C6.66954 7.19117 6.63086 7.09749 6.63086 6.99986V2.21024C6.63086 2.00681 6.79586 1.8418 6.9993 1.8418C7.20274 1.8418 7.36774 2.0068 7.36774 2.21024V6.84726L9.96779 9.44731C10.1119 9.59139 10.1119 9.82455 9.96779 9.96825C9.89595 10.0401 9.80161 10.0761 9.70726 10.0761L9.70723 10.0762Z" fill="#FF8831"/>
											</svg>
											<span class="textOrange" [innerHtml]="getAssignDeadlineTime(item.missedTime, 30) | formatTime"></span> Left</span>
										</ng-container>
										<ng-template #missedAlertTime>
											<span class="textRed">
											<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
											<path d="M7 14C3.14008 14 0 10.86 0 7C0 3.14005 3.14005 0 7 0C10.86 0 14 3.14005 14 7C14 10.86 10.86 14 7 14ZM7 0.736682C3.54632 0.736682 0.736682 3.54632 0.736682 7C0.736682 10.4537 3.54632 13.2633 7 13.2633C10.4537 13.2633 13.2633 10.4537 13.2633 7C13.2633 3.54632 10.4537 0.736682 7 0.736682Z" fill="#DF0000"/>
											<path d="M9.70723 10.0762C9.61288 10.0762 9.51854 10.0402 9.4467 9.96833L6.73875 7.26039C6.66954 7.19117 6.63086 7.09749 6.63086 6.99986V2.21024C6.63086 2.00681 6.79586 1.8418 6.9993 1.8418C7.20274 1.8418 7.36774 2.0068 7.36774 2.21024V6.84726L9.96779 9.44731C10.1119 9.59139 10.1119 9.82455 9.96779 9.96825C9.89595 10.0401 9.80161 10.0761 9.70726 10.0761L9.70723 10.0762Z" fill="#DF0000"/>
											</svg>
											<span class="textRed" [innerHtml]="getAssignLateTime(item.missedTime, 0) | formatTime"></span> Late</span>
										</ng-template>
									</li>
								</ul>
							</div>

							<!-- <div class="p-0">
								<a href="javascript:;" (click)="markLeadComplete(index, item)" *ngIf="!item.loading" class="noti_btn">Mark Completed</a>
								<a href="javascript:;" *ngIf="item.loading" class="noti_btn"><i class="fa fa-spinner fa-spin"></i> Mark Completed</a>
							</div> -->
						</div>
					</ng-template>
			</ng-select>
			<!-- <div class="email-content-box row align-items-center m-0 justify-content-between">
				<div class="col-7 p-0">
					<p class="alert_time">[<span>{{ lead.r_date | date }}</span> at <span>{{ lead.r_date | date: "shortTime" }}</span>]</p>
					<ul class="notification_items">
						<li><p>ID:</p><span>{{ lead.project_name | projectAbbr }}{{ lead.id }}</span></li>
						<li><p>Client:</p><span>{{ lead.name }}</span></li>
						<li><p>Agent:</p><span>{{ lead.lead_assigned_agent_name }}</span></li>
						<li><p>Last Status:</p><span>{{ lead.status }}</span></li>
					</ul>
					<!-- <p class="email-location"> </p>
					<br />
					<p class="email-location"> </p>
					<br />
					<p class="email-location"> </p>
					<br />
					<p class="email-location"></p> -->
					<!-- <a class="af-remove-email" href="javascript:;" (click)="removeLead(indx)">x</a> --
				</div>

				<div class="col-5 p-0">
					<a href="javascript:;" (click)="markLeadComplete(indx, lead)" *ngIf="!lead.loading" class="noti_btn">Mark Completed</a>
					<a href="javascript:;" *ngIf="lead.loading" class="noti_btn"><i class="fa fa-spinner fa-spin"></i> Mark Completed</a>
				</div>
			</div> -->
		</div>

	</div>
</div>


<!-- ProofReader Assign Me Model -->
<div class="paid-modal-m alertsAssign">
	<div class="modal fade" id="assignLeadModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel2" aria-hidden="true">
		<div class="modal-dialog" role="document">
			<button type="button" class="close" data-dismiss="modal" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel2">
					Are you sure you want to assign this
					<span *ngIf="alertType == 'lead'"> lead </span>
					<span *ngIf="alertType == 'unpaid'"> order </span>
					to yourself?
				</h5>
			</div>
			<div class="modal-content">
				<div class="modal-body">
					<div class="action-btns">
						<a href="javascript:;" data-dismiss="modal" aria-label="Close">NO</a>

						<a href="javascript:;" *ngIf="alertType == 'lead'" class="yes-btn bgOrange" (click)="assignToMe_Sales_Lead()">YES</a>
						<a href="javascript:;" *ngIf="alertType == 'unpaid'" class="yes-btn bgOrange" (click)="assignToMe_Sales_Unpaid()">YES</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
